import type { PremiseDataDocument } from '../../../interfaces/containers/premises/PremiseData';

export function hasInterruptibleService(masterData: PremiseDataDocument): boolean {
	return masterData?.data?.service?.electric?.interruptible;
}
